var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('p',{staticClass:"info"},[_vm._v("\n    You're using the free version of Youmi Offer Detect.We suggest that the results are only used\n    to evaluate APP offers\n  ")]),_c('euler',{attrs:{"source":"youmi-offers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }